import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

import {
  Bar,
  BarChart,
  CartesianGrid,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'
import { CommonAPICall } from '../CommonAPiContext/context';

const CommonBarChart = ({ chartData, color, type, value, checkDataType, vendorName, buyerName = '',sku }) => {
  const navigate = useNavigate()
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('userData')))
  const [tickFontSize, setTickFontSize] = useState('12px')
  const [interval, setInterval] = useState(0)
  const { t } = useTranslation()
  const { Norelateddatafound } = t("bigbarChart")
  const { addFilterData } = CommonAPICall()
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      if (width < 500) {
        setTickFontSize('8px')
        setInterval(1) // Show fewer ticks
      } else if (width < 768) {
        setTickFontSize('10px')
        setInterval(0) // Show all ticks
      } else {
        setTickFontSize('12px')
        setInterval(0) // Show all ticks
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleBarClick = (entry) => {
    const role = window?.location?.pathname;
  
    if (user?.userGroupName === "OVERSEAS_ROLE") return;
    if (checkDataType === "Shipweek") return;
  
    const requestType = entry?.activePayload?.[0]?.payload?.requestType;
  
    const isVendor = role.includes('vendor');
  
    const userId = isVendor ? user?.supplierId : user?.hftOracleId;
    const tableName = isVendor ? 'VendorChangeReqTable' : 'BuyerReqTable';
  
    addFilterData({
      hftUserId: userId,
      tableName: tableName,
      buyerName:buyerName?{"id": buyerName,"value": buyerName}:{},
      vendorName:vendorName?{"id": localStorage.getItem('vendorNumber'),"value": vendorName}:{},
      sku:sku?{"id": localStorage.getItem('sku'),"value":sku}:{},
      clFilter: [
        {
          column: 'REQUEST TYPE',
          values: [requestType]
        }
      ]
    });
  
    setTimeout(() => {
      navigate(
        isVendor
          ? `/vendor/po_change_requests`
          : `/buyer/hft_buyer_change_requests`
      );
    }, 300);
  };

  const isLargeScreen = useMediaQuery({ query: '(min-width: 657px)' });
  const screenWidthPercentage = (window.innerWidth / window.screen.width) * 100;

  return (
    <div className='w-full flex'>

      {/* Check if all counts are zero */}
      {chartData && chartData.length > 0 && chartData.every(item => item.Count === 0) ? (
        // <p>No Related Data Found</p> 
        <div className="flex items-center justify-center w-full h-180">
          <p className="text-m font ">{Norelateddatafound}</p>
        </div>
      ) : (
        <ResponsiveContainer width='100%' height={180}>
          <BarChart
            data={chartData}
            margin={{
              top: 5,
              right: 5,
              left: 5,
              bottom: 5
            }}
            onClick={(e) => handleBarClick(e)}
          >
            <CartesianGrid strokeDasharray='5 5' />
            <XAxis
              dataKey={type}
              className='text-xs gap-1 font-medium'
              tick={{ fontSize: isLargeScreen ? '10px' : '11px' }}
              interval={interval}
              angle={isLargeScreen ? '-10' : '0'}
              textAnchor='middle'
              tickOffset={isLargeScreen ? 50 : 0} // Add this line
            />
            <YAxis className='text-xs font-medium' />
            <Tooltip
              labelStyle={{ display: 'none' }}
              contentStyle={{
                background: 'white',
                borderRadius: '8px',
                fontSize: '12px'
              }}
            />
            <Bar
              dataKey={value}
              fill={color}
              activeBar={<Rectangle fill='gray' stroke={color} />}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );

}

export default CommonBarChart
